
import { defineComponent, PropType } from 'vue'
import { CheckStatus, ScaCheckStatus } from '~/types/types'

/**
 * Nav header component for run details page. Lists:
 *
 * - Information about run like branch name, PR, commits, time taken, time created and other runs on the branch.
 */
export default defineComponent({
  name: 'RunHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    status: {
      type: String as PropType<CheckStatus | ScaCheckStatus>,
      default: undefined
    }
  }
})
